module.exports = __webpack_public_path__ + "static/media/art12.5d6e3aec.jpg";